import * as actions from './actions'

const initState = {
    isLoading: false,
    users: null,
    user: null,
    roles: null,
    role: null,
    customers: null,
    newUserId: null,
    emailsMembership: null,
    newRoleId: null,
    isLoadingUser: false
}

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.USERS_REQUEST:
            return {
                ...state,
                ...{
                    isLoading: true
                }
            }
        case actions.USERS_SUCCESS:
            return {
                ...state,
                ...{
                    users: action.users,
                    isLoading: false
                }
            }
        case actions.USERS_ERROR:
            return {
                ...state,
                ...{
                    isLoading: false
                }
            }
        case actions.USERS_ERROR:
            return {
                ...state,
                ...{
                    isLoading: false
                }
            }
        case actions.USER_REQUEST:
            return {
                ...state,
                isLoadingUser: true,
            }
        case actions.USER_REQUEST:
            return {
                ...state,
                isLoadingUser: true,
            }
        case actions.USER_SUCCESS:
            return {
                ...state,
                ...{
                    user: action.user,
                    isLoadingUser: false
                }
            }
        case actions.ROLES_REQUEST_SUCCESS:
            return {
                ...state,
                ...{
                    roles: action.roles
                }
            }
        case actions.ROLE_REQUEST_SUCCESS:
            return {
                ...state,
                ...{
                    role: action.role
                }
            }
        case actions.ROLE_CREATE_SUCCESS:
            return {
                ...state,
                ...{
                    newRoleId: action.newRoleId
                }
            }
        case actions.CUSTOMERS_REQUEST_SUCCESS:
            return {
                ...state,
                ...{
                    customers: action.customers
                }
            }
        case actions.USER_CREATE_SUCCESS:
            return {
                ...state,
                ...{
                    newUserId: action.newUserId
                }
            }
        case actions.USERS_CHECK_MEMBERSHIP_SUCCESS:
            return {
                ...state,
                ...{
                    emailsMembership: action.emailsMembership
                }
            }
        default:
            return state
    }
}